<template>
  <RatioBox :ratio="ratio">
    <div class="v-full" style="position: relative">
      <slot></slot>
      <Empty :image="emptyAssets" :description="description" class="empty-assets" />
    </div>
  </RatioBox>
</template>
<script>
import { Empty } from 'ant-design-vue'
import RatioBox from '@/components/behavior/ratio-box/index.vue'
import emptyVideo from '@/assets/empty-video.svg'
import emptyContent from '@/assets/empty-content.svg'

export default {
  name: 'CocAssetsEmpty',
  props: {
    ratio: {
      type: Number,
      default: 16 / 9
    },
    srcType: {
      type: String, // video | file
      required: true
    }
  },
  components: {
    RatioBox,
    Empty
  },
  data() {
    const _this = this
    const srcType = this.srcType
    let emptyAssets = null

    if (srcType === 'video') {
      emptyAssets = emptyVideo
    } else if (srcType === 'file') {
      emptyAssets = emptyContent
    }

    return {
      emptyAssets,
      get description () {
        if (_this.srcType === 'video') return _this.$t('home.NoVideoRecord')
        return _this.$t('home.NoFiles')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.empty-assets {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  ::v-deep .ant-empty-description {
      color: #999b9f;
    }
}
</style>
